export function calculatedGridValue(params) {
  const formula = params.colDef.context?.calculation;
  if (!formula || !['+', '-', '*', '/'].includes(formula.operator)) return null;
  const number = (field) => {
    if (!field || !params.api.getColumn(field)) return null;
    const value = params.getValue(field);
    if (!['number', 'string'].includes(typeof value) || String(value).trim() === '') return null;
    const parsed = Number(String(value).replace(/,/g, ''));
    return Number.isFinite(parsed) ? parsed : null;
  };
  const left = number(formula.left);
  const right = number(formula.right);
  if (left === null || right === null) return null;
  const value = { '+': () => left + right, '-': () => left - right,
    '*': () => left * right, '/': () => right === 0 ? null : left / right }[formula.operator]();
  return Number.isFinite(value) ? value : null;
}
